import React from 'react';
import { X } from 'lucide-react';
import { EXTERNAL_LINKS } from '../../constants/links';
import { avatarColor } from '../../utils/avatarColor';

export const PromoModal: React.FC<{
  sharerName: string;
  onDismiss: () => void;
}> = ({ sharerName, onDismiss }) => {
  const initial = sharerName.charAt(0).toUpperCase();
  const color = avatarColor(sharerName);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 p-8 text-center relative">
        <button
          onClick={onDismiss}
          className="absolute top-4 right-4 p-1 text-gray-400 hover:text-gray-600 rounded-lg transition-colors"
          aria-label="Close"
        >
          <X className="w-4 h-4" />
        </button>

        <div
          className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-5 text-xl font-semibold text-white"
          style={{ backgroundColor: color }}
        >
          {initial}
        </div>

        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          <span style={{ color }}>{sharerName}</span>{' '}
          shared these notes with you.
        </h2>

        <p className="text-sm text-gray-500 mb-6">
          Skylarq automatically turns your meetings into clear, searchable notes. Download it and start capturing your own.
        </p>

        <a
          href={EXTERNAL_LINKS.DESKTOP_DOWNLOAD}
          target="_blank"
          rel="noopener noreferrer"
          className="block w-full py-3 bg-gray-900 text-white rounded-xl text-sm font-medium hover:bg-gray-800 transition-colors"
        >
          Download Skylarq
        </a>

        <button
          onClick={onDismiss}
          className="mt-3 text-sm text-gray-400 hover:text-gray-600 transition-colors"
        >
          Maybe later
        </button>
      </div>
    </div>
  );
};
